import React, { Component, PropTypes } from 'react';
import without from 'lodash/without';
import concat from 'lodash/concat';
import partial from 'lodash/partial';
import every from 'lodash/every';
import find from 'lodash/find';
import keys from 'lodash/keys';
import values from 'lodash/values';
import Select from 'react-virtualized-select';

const FREQUENCIES = [
  { value: 'digest', label: 'daily digest' },
  { value: 'immediate', label: 'immediately' }
];

const DEFAULT_FREQUENCY = 'digest';

/**
 * Subcategories watchlist for email/onsite notifications.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class SubcatWatchlist extends Component {
  constructor(props) {
    super(props);

    this.state = { expandedCats: [] };

    this.expandCat = this.expandCat.bind(this);
    this.toggleCat = this.toggleCat.bind(this);
    this.toggleSubcat = this.toggleSubcat.bind(this);
    this.changeFreq = this.changeFreq.bind(this);
    this.getSubcatWatchlist = this.getSubcatWatchlist.bind(this);
  }

  expandCat(cat) {
    const { expandedCats } = this.state;

    if (expandedCats.includes(cat.id)) {
      this.setState({ expandedCats: without(expandedCats, cat.id) });
    } else {
      this.setState({ expandedCats: concat(expandedCats, [cat.id]) });
    }
  }

  toggleCat(cat, e) {
    const { watchCategory, unwatchCategory, watchCategoryOnsite,
      unwatchCategoryOnsite, onsite } = this.props;

    if (e.target.checked) {
      if (onsite) { watchCategoryOnsite(cat); }
      else { watchCategory(cat, DEFAULT_FREQUENCY); }

    } else {
      if (onsite) { unwatchCategoryOnsite(cat); }
      else { unwatchCategory(cat); }
    }
  }

  toggleSubcat(subcat, e) {
    const { watchSubcategory, unwatchSubcategory, watchSubcategoryOnsite,
      unwatchSubcategoryOnsite, onsite } = this.props;

    if (e.target.checked) {
      if (onsite) { watchSubcategoryOnsite(subcat.id); }
      else { watchSubcategory(subcat.id, DEFAULT_FREQUENCY); }

    } else {
      if (onsite) { unwatchSubcategoryOnsite(subcat.id); }
      else { unwatchSubcategory(subcat.id); }
    }
  }

  changeFreq(subcat, freq) {
    const { watchSubcategory } = this.props;
    watchSubcategory(subcat.id, freq);
  }

  /* get watchlist in which subcat is present if any */
  getSubcatWatchlist(subcat) {
    const { onsite, user } = this.props;
    const watchlists = (
      onsite? [
        { onsite: user.watchlist_subcat_ids_onsite }
      ] : [
        { immediate: user.watchlist_subcat_ids_immediate },
        { digest: user.watchlist_subcat_ids_digest }
      ]
    );
    return find(watchlists, list => values(list)[0].includes(subcat.id));
  }

  render() {
    const { categories, onsite, user, atAdmin } = this.props;
    const { expandedCats } = this.state;

    if (!user.is_creative) {
      return null;
    }

    return (
      <div className="notification-subsection subcat-watchlist">
        <div className="row">
          <div className="small-16 medium-6 column">
            <div className="notification-section-header">
              <h5>New Projects</h5>
              <p>Notify { atAdmin? `${user.username}` : 'me' } of new projects in these categories</p>
            </div>
          </div>
        </div>

        { categories.map(cat => {
          const id = `${onsite? 'onsite' : 'email'}-cat-${cat.id}`;
          const checked = every(cat.sub_categories, this.getSubcatWatchlist);
          const expanded = expandedCats.includes(cat.id);

          return (
            <div className="row" key={id}>
              <div className="small-16 medium-offset-3 medium-13 column">
                <div className="checkbox">
                  <input onChange={partial(this.toggleCat, cat)} type="checkbox"
                    className="form-control" checked={checked} id={id} />
                  <label htmlFor={id} className="form-label">{ cat.name }</label>
                  <i className={"fa fa-" + (expanded? "minus" : "plus") }
                    onClick={partial(this.expandCat, cat)} />
                </div>

                { expanded && cat.sub_categories.map(subcat => {
                  const id = `${onsite? 'onsite' : 'email'}-subcat-${subcat.id}`;
                  const watchlist = this.getSubcatWatchlist(subcat);

                  return (
                    <div className="row" key={id}>
                      <div className="column small-10 small-offset-2 medium-9 medium-offset-1">
                        <div className="checkbox">
                          <input onChange={partial(this.toggleSubcat, subcat)}
                            type="checkbox" className="form-control" checked={!!watchlist}
                            id={id} />
                          <label htmlFor={id} className="form-label">{ subcat.name }</label>
                        </div>
                      </div>

                      { !!watchlist && !onsite &&
                      <div className="column small-14 small-offset-2 medium-offset-0 medium-6">
                        <div className="frequency-label">Frequency</div>
                        <span className="tag tag-default tag-sm">
                          <Select onChange={partial(this.changeFreq, subcat)} options={FREQUENCIES}
                            value={keys(watchlist)[0]} clearable={false} searchable={false}
                            simpleValue={true} />
                        </span>
                      </div> }
                    </div>
                  );
                }) }
              </div>
            </div>);
        }) }
      </div>
    );
  }
};

SubcatWatchlist.propTypes = {
  user: PropTypes.object,
  categories: PropTypes.array,
  onsite: PropTypes.bool,
  watchSubcategory: PropTypes.func,
  unwatchSubcategory: PropTypes.func,
  watchCategory: PropTypes.func,
  unwatchCategory: PropTypes.func,
  watchSubcategoryOnsite: PropTypes.func,
  unwatchSubcategoryOnsite: PropTypes.func,
  watchCategoryOnsite: PropTypes.func,
  unwatchCategoryOnsite: PropTypes.func,
  atAdmin: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./account/components/sub_category_watchlist.jsx